/* eslint-disable no-param-reassign */
import { ColorFill } from '@tencent/alloy-renderer/dist/fill/color-fill';
import { CharStruct, DrawPlugin, DrawPluginContext } from '../../../../type/common.interface';

export class ColorBorderPlugin implements DrawPlugin {
    public before(context: DrawPluginContext<CharStruct>): void {
        const { detail } = context.struct;
        const { stroke, strokeWidth, strokeLineCap, strokeLineJoin } = detail;
        const hex = (stroke as ColorFill)?.color?.hex;

        context.canvasContext.lineWidth = strokeWidth * context.scheduleRatio;
        context.canvasContext.lineCap = strokeLineCap;
        context.canvasContext.lineJoin = strokeLineJoin;
        context.canvasContext.strokeStyle = hex;
    }
    public after(context: DrawPluginContext<CharStruct>): void {
        const { detail } = context.struct;
        const { strokeWidth } = detail;
        if (strokeWidth) {
            context.canvasContext.stroke();
        }
    }
}
